import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RbacPermissionsConstant } from '../../../../services/rbac/rbac-permissions.constant';

@Component({
  selector: 'gtd-affiliate-link-with-all',
  templateUrl: './affiliate-link-with-all.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AffiliateLinkWithAllComponent {
  @Input() public data: any;
  public RbacPermissionsConstant = RbacPermissionsConstant;
}
